import { render, staticRenderFns } from "./BossInactiveSubscription.vue?vue&type=template&id=2f7b2199&"
import script from "./BossInactiveSubscription.vue?vue&type=script&lang=js&"
export * from "./BossInactiveSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports